export default __webpack_public_path__ + "static/media/IMG_7585.4a2ac693.jpeg";